import { Component } from '@angular/core';

@Component({
  selector: 'app-customer-sales-analysis',
  standalone: false,
  
  templateUrl: './customer-sales-analysis.component.html',
  styles: ``
})
export class CustomerSalesAnalysisComponent {

}
